import { Entity } from '@backstage/catalog-model';

import { UMAMI_ANALYITCS_TRACKING_ID } from '../constants';

export const isTrackingIdAvailable = (entity: Entity) =>
  Boolean(entity?.metadata.annotations?.[UMAMI_ANALYITCS_TRACKING_ID]);
